export interface CountryType {
  Id: number;
  Value: string | null;
  Name: string;
}
type CountryTypeMap = Record<
  string,
  { Id: number; Value: string | null; Name: string }
>;

export const CountryMap: CountryTypeMap = {
  Afghanistan: { Id: 260, Value: '93', Name: 'Afghanistan' },
  AlandIslands: { Id: 100, Value: '358', Name: 'Aland Islands' },
  Albania: { Id: 103, Value: '355', Name: 'Albania' },
  Algeria: { Id: 104, Value: '213', Name: 'Algeria' },
  AmericanSamoa: { Id: 119, Value: '1684', Name: 'American Samoa' },
  Andorra: { Id: 135, Value: '376', Name: 'Andorra' },
  Angola: { Id: 175, Value: '244', Name: 'Angola' },
  Anguilla: { Id: 200, Value: '1264', Name: 'Anguilla' },
  Antartica: { Id: 261, Value: '672', Name: 'Antartica' },
  AntiguaandBarbuda: { Id: 221, Value: '1268', Name: 'Antigua and Barbuda' },
  Argentina: { Id: 236, Value: '54', Name: 'Argentina' },
  Armenia: { Id: 14, Value: '374', Name: 'Armenia' },
  Aruba: { Id: 13, Value: '297', Name: 'Aruba' },
  Australia: { Id: 1, Value: '61', Name: 'Australia' },
  Austria: { Id: 15, Value: '43', Name: 'Austria' },
  Azerbaijan: { Id: 16, Value: '994', Name: 'Azerbaijan' },
  BahamasThe: { Id: 17, Value: '1242', Name: 'Bahamas, The' },
  Bahrain: { Id: 18, Value: '973', Name: 'Bahrain' },
  Bangladesh: { Id: 19, Value: '880', Name: 'Bangladesh' },
  Barbados: { Id: 20, Value: '1246', Name: 'Barbados' },
  Belarus: { Id: 21, Value: '375', Name: 'Belarus' },
  Belgium: { Id: 22, Value: '32', Name: 'Belgium' },
  Belize: { Id: 23, Value: '501', Name: 'Belize' },
  Benin: { Id: 24, Value: '229', Name: 'Benin' },
  Bermuda: { Id: 25, Value: '1441', Name: 'Bermuda' },
  Bhutan: { Id: 26, Value: '975', Name: 'Bhutan' },
  Bolivia: { Id: 27, Value: '591', Name: 'Bolivia' },
  BonaireSintEustatiusandSaba: {
    Id: 28,
    Value: '599',
    Name: 'Bonaire, Sint Eustatius and Saba',
  },
  BosniaandHerzegovina: {
    Id: 29,
    Value: '387',
    Name: 'Bosnia and Herzegovina',
  },
  Botswana: { Id: 30, Value: '267', Name: 'Botswana' },
  BouvetIsland: { Id: 31, Value: '47', Name: 'Bouvet Island' },
  Brazil: { Id: 32, Value: '55', Name: 'Brazil' },

  BritishIndianOceanTerritory: {
    Id: 33,
    Value: '246',
    Name: 'British Indian Ocean Territory',
  },
  BritishVirginIslands: {
    Id: 250,
    Value: '1284',
    Name: 'British Virgin Islands',
  },
  Brunei: { Id: 34, Value: '673', Name: 'Brunei' },
  Bulgaria: { Id: 35, Value: '359', Name: 'Bulgaria' },
  BurkinaFaso: { Id: 36, Value: '226', Name: 'Burkina Faso' },
  Burundi: { Id: 37, Value: '257', Name: 'Burundi' },
  Cambodia: { Id: 38, Value: '855', Name: 'Cambodia' },
  Cameroon: { Id: 39, Value: '237', Name: 'Cameroon' },
  Canada: { Id: 40, Value: '1', Name: 'Canada' },
  CapeVerde: { Id: 41, Value: '238', Name: 'Cape Verde' },
  CaymanIsland: { Id: 42, Value: '1345', Name: 'Cayman Island' },
  CentralAfricanRepublic: {
    Id: 43,
    Value: '236',
    Name: 'Central African Republic',
  },
  Chad: { Id: 44, Value: '235', Name: 'Chad' },
  Chile: { Id: 45, Value: '56', Name: 'Chile' },
  China: { Id: 46, Value: '86', Name: 'China' },
  ChristmasIsland: { Id: 47, Value: '61', Name: 'Christmas Island' },
  CocosKeelingIslands: {
    Id: 48,
    Value: '61',
    Name: 'Cocos (Keeling) Islands',
  },
  Colombia: { Id: 49, Value: '57', Name: 'Colombia' },
  Comoros: { Id: 50, Value: '269', Name: 'Comoros' },
  Congo: { Id: 51, Value: '242', Name: 'Congo' },
  CongoDRC: { Id: 52, Value: '243', Name: 'Congo (DRC)' },
  CookIslands: { Id: 53, Value: '682', Name: 'Cook Islands' },
  CostaRica: { Id: 54, Value: '506', Name: 'Costa Rica' },
  CotedIvoire: { Id: 55, Value: '225', Name: "Cote d'Ivoire" },
  Croatia: { Id: 56, Value: '385', Name: 'Croatia' },
  Cuba: { Id: 57, Value: '53', Name: 'Cuba' },
  Curacao: { Id: 58, Value: '599', Name: 'Curacao' },
  Cyprus: { Id: 59, Value: '357', Name: 'Cyprus' },
  CzechRepublic: { Id: 60, Value: '420', Name: 'Czech Republic' },
  Denmark: { Id: 61, Value: '45', Name: 'Denmark' },
  Djibouti: { Id: 62, Value: '253', Name: 'Djibouti' },
  Dominica: { Id: 63, Value: '1767', Name: 'Dominica' },
  DominicanRepublic: { Id: 64, Value: '1809', Name: 'Dominican Republic' },
  Ecuador: { Id: 65, Value: '593', Name: 'Ecuador' },
  Egypt: { Id: 66, Value: '20', Name: 'Egypt' },
  ElSalvador: { Id: 67, Value: '503', Name: 'El Salvador' },
  EquatorialGuinea: { Id: 68, Value: '240', Name: 'Equatorial Guinea' },
  Eritrea: { Id: 69, Value: '291', Name: 'Eritrea' },
  Estonia: { Id: 70, Value: '372', Name: 'Estonia' },
  Ethiopia: { Id: 71, Value: '251', Name: 'Ethiopia' },
  FalklandIslandsIslasMalvinas: {
    Id: 72,
    Value: '500',
    Name: 'Falkland Islands ( Islas Malvinas )',
  },
  FaroeIslands: { Id: 73, Value: '298', Name: 'Faroe Islands' },
  Fiji: { Id: 74, Value: '679', Name: 'Fiji' },
  Finland: { Id: 75, Value: '358', Name: 'Finland' },
  France: { Id: 76, Value: '33', Name: 'France' },
  FrenchGuiana: { Id: 77, Value: '594', Name: 'French Guiana' },
  FrenchPolynesia: { Id: 78, Value: '689', Name: 'French Polynesia' },
  FrenchSouthernandAntarcticLands: {
    Id: 79,
    Value: '596',
    Name: 'French Southern and Antarctic Lands',
  },
  Gabon: { Id: 80, Value: '241', Name: 'Gabon' },
  GambiaThe: { Id: 81, Value: '220', Name: 'Gambia, The' },
  Georgia: { Id: 82, Value: '995', Name: 'Georgia' },
  Germany: { Id: 83, Value: '49', Name: 'Germany' },
  Ghana: { Id: 84, Value: '233', Name: 'Ghana' },
  Gibraltar: { Id: 85, Value: '350', Name: 'Gibraltar' },
  Greece: { Id: 86, Value: '30', Name: 'Greece' },
  Greenland: { Id: 87, Value: '299', Name: 'Greenland' },
  Grenada: { Id: 88, Value: '1473', Name: 'Grenada' },
  Guadeloupe: { Id: 89, Value: '590', Name: 'Guadeloupe' },
  Guam: { Id: 90, Value: '1671', Name: 'Guam' },
  Guatemala: { Id: 91, Value: '502', Name: 'Guatemala' },
  Guernsey: { Id: 262, Value: '44', Name: 'Guernsey' },
  Guinea: { Id: 93, Value: '224', Name: 'Guinea' },
  GuineaBissau: { Id: 94, Value: '245', Name: 'Guinea-Bissau' },
  Guyana: { Id: 95, Value: '592', Name: 'Guyana' },
  Haiti: { Id: 96, Value: '509', Name: 'Haiti' },
  HeardIslandandMcDonaldIslands: {
    Id: 97,
    Value: '672',
    Name: 'Heard Island and McDonald Islands',
  },
  HolySeeVaticanCity: {
    Id: 98,
    Value: '379',
    Name: 'Holy See (Vatican City)',
  },
  Honduras: { Id: 99, Value: '504', Name: 'Honduras' },
  HongKongSAR: { Id: 2, Value: '852', Name: 'Hong Kong SAR' },
  Hungary: { Id: 101, Value: '36', Name: 'Hungary' },
  Iceland: { Id: 102, Value: '354', Name: 'Iceland' },
  India: { Id: 3, Value: '91', Name: 'India' },
  Indonesia: { Id: 4, Value: '62', Name: 'Indonesia' },
  Iran: { Id: 105, Value: '98', Name: 'Iran' },
  Iraq: { Id: 106, Value: '964', Name: 'Iraq' },
  IrelandRepublicof: { Id: 107, Value: '353', Name: 'Ireland, Republic of' },
  IsleofMan: { Id: 108, Value: '44', Name: 'Isle of Man' },
  Israel: { Id: 109, Value: '972', Name: 'Israel' },
  Italy: { Id: 110, Value: '39', Name: 'Italy' },
  Jamaica: { Id: 111, Value: '1876', Name: 'Jamaica' },
  Japan: { Id: 112, Value: '81', Name: 'Japan' },
  Jersey: { Id: 263, Value: '44', Name: 'Jersey' },
  Jordan: { Id: 114, Value: '962', Name: 'Jordan' },
  Kazakhstan: { Id: 115, Value: '7', Name: 'Kazakhstan' },
  Kenya: { Id: 116, Value: '254', Name: 'Kenya' },
  Kiribati: { Id: 117, Value: '686', Name: 'Kiribati' },
  KoreaNorth: { Id: 118, Value: '850', Name: 'Korea, North' },
  KoreaSouth: { Id: 5, Value: '82', Name: 'Korea, South' },
  Kosovo: { Id: 252, Value: '381', Name: 'Kosovo' },
  Kuwait: { Id: 120, Value: '965', Name: 'Kuwait' },
  Kyrgyzstan: { Id: 121, Value: '996', Name: 'Kyrgyzstan' },
  Laos: { Id: 122, Value: '856', Name: 'Laos' },
  Latvia: { Id: 123, Value: '371', Name: 'Latvia' },
  Lebanon: { Id: 124, Value: '961', Name: 'Lebanon' },
  Lesotho: { Id: 125, Value: '266', Name: 'Lesotho' },
  Liberia: { Id: 126, Value: '231', Name: 'Liberia' },
  Libya: { Id: 127, Value: '218', Name: 'Libya' },
  Liechtenstein: { Id: 128, Value: '423', Name: 'Liechtenstein' },
  Lithuania: { Id: 129, Value: '370', Name: 'Lithuania' },
  Luxembourg: { Id: 130, Value: '352', Name: 'Luxembourg' },
  MacaoSAR: { Id: 131, Value: '853', Name: 'Macao SAR' },
  MacedoniaFYRO: { Id: 132, Value: '389', Name: 'Macedonia, FYRO' },
  Madagascar: { Id: 133, Value: '261', Name: 'Madagascar' },
  Malawi: { Id: 134, Value: '265', Name: 'Malawi' },
  Malaysia: { Id: 6, Value: '60', Name: 'Malaysia' },
  Maldives: { Id: 136, Value: '960', Name: 'Maldives' },
  Mali: { Id: 137, Value: '223', Name: 'Mali' },
  Malta: { Id: 138, Value: '356', Name: 'Malta' },
  MarshallIslands: { Id: 139, Value: '692', Name: 'Marshall Islands' },
  Martinique: { Id: 140, Value: '596', Name: 'Martinique' },
  Mauritania: { Id: 141, Value: '222', Name: 'Mauritania' },
  Mauritius: { Id: 142, Value: '230', Name: 'Mauritius' },
  Mayotte: { Id: 143, Value: '269', Name: 'Mayotte' },
  Mexico: { Id: 144, Value: '52', Name: 'Mexico' },
  Micronesia: { Id: 145, Value: '691', Name: 'Micronesia' },
  Moldova: { Id: 146, Value: '373', Name: 'Moldova' },
  Monaco: { Id: 147, Value: '377', Name: 'Monaco' },
  Mongolia: { Id: 148, Value: '976', Name: 'Mongolia' },
  Montenegro: { Id: 149, Value: '382', Name: 'Montenegro' },
  Montserrat: { Id: 150, Value: '1664', Name: 'Montserrat' },
  Morocco: { Id: 151, Value: '212', Name: 'Morocco' },
  Mozambique: { Id: 152, Value: '258', Name: 'Mozambique' },
  Myanmar: { Id: 153, Value: '95', Name: 'Myanmar' },
  Namibia: { Id: 154, Value: '264', Name: 'Namibia' },
  Nauru: { Id: 155, Value: '674', Name: 'Nauru' },
  Nepal: { Id: 156, Value: '977', Name: 'Nepal' },
  Netherlands: { Id: 157, Value: '31', Name: 'Netherlands' },
  NewCaledonia: { Id: 158, Value: '687', Name: 'New Caledonia' },
  NewZealand: { Id: 159, Value: '64', Name: 'New Zealand' },
  Nicaragua: { Id: 160, Value: '505', Name: 'Nicaragua' },
  Niger: { Id: 161, Value: '227', Name: 'Niger' },
  Nigeria: { Id: 162, Value: '234', Name: 'Nigeria' },
  Niue: { Id: 163, Value: '683', Name: 'Niue' },
  NorfolkIsland: { Id: 164, Value: '6723', Name: 'Norfolk Island' },
  NorthernMarianaIslands: {
    Id: 165,
    Value: '1670',
    Name: 'Northern Mariana Islands',
  },
  Norway: { Id: 166, Value: '47', Name: 'Norway' },
  Oman: { Id: 167, Value: '968', Name: 'Oman' },
  Pakistan: { Id: 168, Value: '92', Name: 'Pakistan' },
  Palau: { Id: 169, Value: '680', Name: 'Palau' },
  PalestinianAuthority: {
    Id: 170,
    Value: '970',
    Name: 'Palestinian Authority',
  },
  Panama: { Id: 171, Value: '507', Name: 'Panama' },
  PapuaNewGuinea: { Id: 172, Value: '675', Name: 'Papua New Guinea' },
  Paraguay: { Id: 173, Value: '595', Name: 'Paraguay' },
  Peru: { Id: 174, Value: '51', Name: 'Peru' },
  Philippines: { Id: 7, Value: '63', Name: 'Philippines' },
  PitcairnIslands: { Id: 176, Value: '872', Name: 'Pitcairn Islands' },
  Poland: { Id: 177, Value: '48', Name: 'Poland' },
  Portugal: { Id: 178, Value: '351', Name: 'Portugal' },
  PuertoRico: { Id: 179, Value: '1787', Name: 'Puerto Rico' },
  Qatar: { Id: 180, Value: '974', Name: 'Qatar' },
  Reunion: { Id: 181, Value: '262', Name: 'Reunion' },
  Romania: { Id: 182, Value: '40', Name: 'Romania' },
  Russia: { Id: 183, Value: '7', Name: 'Russia' },
  Rwanda: { Id: 184, Value: '250', Name: 'Rwanda' },
  SaintBarthelemy: { Id: 185, Value: '590', Name: 'Saint Barthelemy' },
  SaintHelenaAscensionandTristandaCunha: {
    Id: 186,
    Value: '290',
    Name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  SaintKittsandNevis: {
    Id: 187,
    Value: '1869',
    Name: 'Saint Kitts and Nevis',
  },
  SaintLucia: { Id: 188, Value: '1758', Name: 'Saint Lucia' },
  SaintMartin: { Id: 189, Value: '590', Name: 'Saint Martin' },

  SaintPierreandMiquelon: {
    Id: 190,
    Value: '508',
    Name: 'Saint Pierre and Miquelon',
  },
  SaintVincentandtheGrenadines: {
    Id: 191,
    Value: '1784',
    Name: 'Saint Vincent and the Grenadines',
  },
  Samoa: { Id: 192, Value: '685', Name: 'Samoa' },
  SanMarino: { Id: 193, Value: '378', Name: 'San Marino' },
  SaoTomeandPrincipe: {
    Id: 194,
    Value: '239',
    Name: 'Sao Tome and Principe',
  },
  SaudiArabia: { Id: 195, Value: '966', Name: 'Saudi Arabia' },
  Senegal: { Id: 196, Value: '221', Name: 'Senegal' },
  Serbia: { Id: 197, Value: '381', Name: 'Serbia' },
  Seychelles: { Id: 198, Value: '248', Name: 'Seychelles' },
  SierraLeone: { Id: 199, Value: '232', Name: 'Sierra Leone' },
  Singapore: { Id: 8, Value: '65', Name: 'Singapore' },
  SintMaarten: { Id: 201, Value: '1721', Name: 'Sint Maarten' },
  Slovakia: { Id: 202, Value: '421', Name: 'Slovakia' },
  Slovenia: { Id: 203, Value: '386', Name: 'Slovenia' },
  SolomonIslands: { Id: 204, Value: '677', Name: 'Solomon Islands' },
  Somalia: { Id: 205, Value: '252', Name: 'Somalia' },
  SouthAfrica: { Id: 206, Value: '27', Name: 'South Africa' },
  SouthGeorgiaandtheSouthSandwichIslands: {
    Id: 207,
    Value: '500',
    Name: 'South Georgia and the South Sandwich Islands',
  },
  SouthSudan: { Id: 208, Value: '211', Name: 'South Sudan' },
  Spain: { Id: 209, Value: '34', Name: 'Spain' },
  SriLanka: { Id: 210, Value: '94', Name: 'Sri Lanka' },
  Sudan: { Id: 211, Value: '249', Name: 'Sudan' },
  Suriname: { Id: 212, Value: '597', Name: 'Suriname' },
  SvalbardandJanMayen: {
    Id: 213,
    Value: '47',
    Name: 'Svalbard and Jan Mayen',
  },
  Swaziland: { Id: 214, Value: '268', Name: 'Swaziland' },
  Sweden: { Id: 215, Value: '46', Name: 'Sweden' },
  Switzerland: { Id: 216, Value: '41', Name: 'Switzerland' },
  Syria: { Id: 217, Value: '963', Name: 'Syria' },
  Taiwan: { Id: 9, Value: '886', Name: 'Taiwan' },
  Tajikistan: { Id: 219, Value: '992', Name: 'Tajikistan' },
  Tanzania: { Id: 220, Value: '255', Name: 'Tanzania' },
  Thailand: { Id: 10, Value: '66', Name: 'Thailand' },
  TimorLeste: { Id: 222, Value: '670', Name: 'Timor-Leste' },
  Togo: { Id: 223, Value: '228', Name: 'Togo' },
  Tokelau: { Id: 224, Value: '690', Name: 'Tokelau' },
  Tonga: { Id: 225, Value: '676', Name: 'Tonga' },
  TrinidadandTobago: { Id: 226, Value: '1868', Name: 'Trinidad and Tobago' },
  Tunisia: { Id: 227, Value: '216', Name: 'Tunisia' },
  Turkey: { Id: 228, Value: '90', Name: 'Turkey' },
  Turkmenistan: { Id: 229, Value: '993', Name: 'Turkmenistan' },
  TurksandCaicosIslands: {
    Id: 230,
    Value: '1649',
    Name: 'Turks and Caicos Islands',
  },
  Tuvalu: { Id: 231, Value: '688', Name: 'Tuvalu' },
  Uganda: { Id: 232, Value: '256', Name: 'Uganda' },
  Ukraine: { Id: 233, Value: '380', Name: 'Ukraine' },
  UnitedArabEmirates: { Id: 234, Value: '971', Name: 'United Arab Emirates' },
  UnitedKingdom: { Id: 235, Value: '44', Name: 'United Kingdom' },
  USMinorOutlyingIslands: {
    Id: 237,
    Value: '1',
    Name: 'US Minor Outlying Islands',
  },
  USA: { Id: 11, Value: '1', Name: 'USA' },
  Uruguay: { Id: 238, Value: '598', Name: 'Uruguay' },
  Uzbekistan: { Id: 239, Value: '998', Name: 'Uzbekistan' },
  Vanuatu: { Id: 240, Value: '678', Name: 'Vanuatu' },
  Venezuela: { Id: 241, Value: '58', Name: 'Venezuela' },
  Vietnam: { Id: 242, Value: '84', Name: 'Vietnam' },
  VirginIslandsUS: { Id: 244, Value: '1340', Name: 'Virgin Islands (U.S.)' },
  WallisandFutuna: { Id: 245, Value: '681', Name: 'Wallis and Futuna' },
  WesternSahara: { Id: 246, Value: '212', Name: 'Western Sahara' },
  Yemen: { Id: 247, Value: '967', Name: 'Yemen' },
  Zambia: { Id: 248, Value: '260', Name: 'Zambia' },
  Zimbabwe: { Id: 249, Value: '263', Name: 'Zimbabwe' },
};
export const PopularCountries: CountryType[] = [
  { Id: 1, Value: '61', Name: 'Australia' },
  { Id: 159, Value: '64', Name: 'New Zealand' },
  { Id: 11, Value: '1', Name: 'USA' },
  { Id: 3, Value: '91', Name: 'India' },
  { Id: 235, Value: '44', Name: 'United Kingdom' },
  // When selected this displays as "USA" given they have the same "Value" field
  { Id: 40, Value: '1', Name: 'Canada' },
  { Id: 206, Value: '27', Name: 'South Africa' },
  { Id: 8, Value: '65', Name: 'Singapore' },
  { Id: 46, Value: '86', Name: 'China' },
  { Id: 183, Value: '7', Name: 'Russia' },
];

export const Country: CountryType[] = [
  { Id: 260, Value: '93', Name: 'Afghanistan' },
  { Id: 100, Value: '358', Name: 'Aland Islands' },
  { Id: 103, Value: '355', Name: 'Albania' },
  { Id: 104, Value: '213', Name: 'Algeria' },
  { Id: 119, Value: '1684', Name: 'American Samoa' },
  { Id: 135, Value: '376', Name: 'Andorra' },
  { Id: 175, Value: '244', Name: 'Angola' },
  { Id: 200, Value: '1264', Name: 'Anguilla' },
  { Id: 261, Value: '672', Name: 'Antartica' },
  { Id: 221, Value: '1268', Name: 'Antigua and Barbuda' },
  { Id: 236, Value: '54', Name: 'Argentina' },
  { Id: 14, Value: '374', Name: 'Armenia' },
  { Id: 13, Value: '297', Name: 'Aruba' },
  { Id: 1, Value: '61', Name: 'Australia' },
  { Id: 15, Value: '43', Name: 'Austria' },
  { Id: 16, Value: '994', Name: 'Azerbaijan' },
  { Id: 17, Value: '1242', Name: 'Bahamas, The' },
  { Id: 18, Value: '973', Name: 'Bahrain' },
  { Id: 19, Value: '880', Name: 'Bangladesh' },
  { Id: 20, Value: '1246', Name: 'Barbados' },
  { Id: 21, Value: '375', Name: 'Belarus' },
  { Id: 22, Value: '32', Name: 'Belgium' },
  { Id: 23, Value: '501', Name: 'Belize' },
  { Id: 24, Value: '229', Name: 'Benin' },
  { Id: 25, Value: '1441', Name: 'Bermuda' },
  { Id: 26, Value: '975', Name: 'Bhutan' },
  { Id: 27, Value: '591', Name: 'Bolivia' },
  {
    Id: 28,
    Value: '599',
    Name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    Id: 29,
    Value: '387',
    Name: 'Bosnia and Herzegovina',
  },
  { Id: 30, Value: '267', Name: 'Botswana' },
  { Id: 31, Value: '47', Name: 'Bouvet Island' },
  { Id: 32, Value: '55', Name: 'Brazil' },

  {
    Id: 33,
    Value: '246',
    Name: 'British Indian Ocean Territory',
  },
  {
    Id: 250,
    Value: '1284',
    Name: 'British Virgin Islands',
  },
  { Id: 34, Value: '673', Name: 'Brunei' },
  { Id: 35, Value: '359', Name: 'Bulgaria' },
  { Id: 36, Value: '226', Name: 'Burkina Faso' },
  { Id: 37, Value: '257', Name: 'Burundi' },
  { Id: 38, Value: '855', Name: 'Cambodia' },
  { Id: 39, Value: '237', Name: 'Cameroon' },
  { Id: 40, Value: '1', Name: 'Canada' },
  { Id: 41, Value: '238', Name: 'Cape Verde' },
  { Id: 42, Value: '1345', Name: 'Cayman Island' },
  {
    Id: 43,
    Value: '236',
    Name: 'Central African Republic',
  },
  { Id: 44, Value: '235', Name: 'Chad' },
  { Id: 45, Value: '56', Name: 'Chile' },
  { Id: 46, Value: '86', Name: 'China' },
  { Id: 47, Value: '61', Name: 'Christmas Island' },
  {
    Id: 48,
    Value: '61',
    Name: 'Cocos (Keeling) Islands',
  },
  { Id: 49, Value: '57', Name: 'Colombia' },
  { Id: 50, Value: '269', Name: 'Comoros' },
  { Id: 51, Value: '242', Name: 'Congo' },
  { Id: 52, Value: '243', Name: 'Congo (DRC)' },
  { Id: 53, Value: '682', Name: 'Cook Islands' },
  { Id: 54, Value: '506', Name: 'Costa Rica' },
  { Id: 55, Value: '225', Name: "Cote d'Ivoire" },
  { Id: 56, Value: '385', Name: 'Croatia' },
  { Id: 57, Value: '53', Name: 'Cuba' },
  { Id: 58, Value: '599', Name: 'Curacao' },
  { Id: 59, Value: '357', Name: 'Cyprus' },
  { Id: 60, Value: '420', Name: 'Czech Republic' },
  { Id: 61, Value: '45', Name: 'Denmark' },
  { Id: 62, Value: '253', Name: 'Djibouti' },
  { Id: 63, Value: '1767', Name: 'Dominica' },
  { Id: 64, Value: '1809', Name: 'Dominican Republic' },
  { Id: 65, Value: '593', Name: 'Ecuador' },
  { Id: 66, Value: '20', Name: 'Egypt' },
  { Id: 67, Value: '503', Name: 'El Salvador' },
  { Id: 68, Value: '240', Name: 'Equatorial Guinea' },
  { Id: 69, Value: '291', Name: 'Eritrea' },
  { Id: 70, Value: '372', Name: 'Estonia' },
  { Id: 71, Value: '251', Name: 'Ethiopia' },
  {
    Id: 72,
    Value: '500',
    Name: 'Falkland Islands ( Islas Malvinas )',
  },
  { Id: 73, Value: '298', Name: 'Faroe Islands' },
  { Id: 74, Value: '679', Name: 'Fiji' },
  { Id: 75, Value: '358', Name: 'Finland' },
  { Id: 76, Value: '33', Name: 'France' },
  { Id: 77, Value: '594', Name: 'French Guiana' },
  { Id: 78, Value: '689', Name: 'French Polynesia' },
  {
    Id: 79,
    Value: '596',
    Name: 'French Southern and Antarctic Lands',
  },
  { Id: 80, Value: '241', Name: 'Gabon' },
  { Id: 81, Value: '220', Name: 'Gambia, The' },
  { Id: 82, Value: '995', Name: 'Georgia' },
  { Id: 83, Value: '49', Name: 'Germany' },
  { Id: 84, Value: '233', Name: 'Ghana' },
  { Id: 85, Value: '350', Name: 'Gibraltar' },
  { Id: 86, Value: '30', Name: 'Greece' },
  { Id: 87, Value: '299', Name: 'Greenland' },
  { Id: 88, Value: '1473', Name: 'Grenada' },
  { Id: 89, Value: '590', Name: 'Guadeloupe' },
  { Id: 90, Value: '1671', Name: 'Guam' },
  { Id: 91, Value: '502', Name: 'Guatemala' },
  { Id: 262, Value: '44', Name: 'Guernsey' },
  { Id: 93, Value: '224', Name: 'Guinea' },
  { Id: 94, Value: '245', Name: 'Guinea-Bissau' },
  { Id: 95, Value: '592', Name: 'Guyana' },
  { Id: 96, Value: '509', Name: 'Haiti' },
  {
    Id: 97,
    Value: '672',
    Name: 'Heard Island and McDonald Islands',
  },
  {
    Id: 98,
    Value: '379',
    Name: 'Holy See (Vatican City)',
  },
  { Id: 99, Value: '504', Name: 'Honduras' },
  { Id: 2, Value: '852', Name: 'Hong Kong SAR' },
  { Id: 101, Value: '36', Name: 'Hungary' },
  { Id: 102, Value: '354', Name: 'Iceland' },
  { Id: 3, Value: '91', Name: 'India' },
  { Id: 4, Value: '62', Name: 'Indonesia' },
  { Id: 105, Value: '98', Name: 'Iran' },
  { Id: 106, Value: '964', Name: 'Iraq' },
  { Id: 107, Value: '353', Name: 'Ireland, Republic of' },
  { Id: 108, Value: '44', Name: 'Isle of Man' },
  { Id: 109, Value: '972', Name: 'Israel' },
  { Id: 110, Value: '39', Name: 'Italy' },
  { Id: 111, Value: '1876', Name: 'Jamaica' },
  { Id: 112, Value: '81', Name: 'Japan' },
  { Id: 263, Value: '44', Name: 'Jersey' },
  { Id: 114, Value: '962', Name: 'Jordan' },
  { Id: 115, Value: '7', Name: 'Kazakhstan' },
  { Id: 116, Value: '254', Name: 'Kenya' },
  { Id: 117, Value: '686', Name: 'Kiribati' },
  { Id: 118, Value: '850', Name: 'Korea, North' },
  { Id: 5, Value: '82', Name: 'Korea, South' },
  { Id: 252, Value: '381', Name: 'Kosovo' },
  { Id: 120, Value: '965', Name: 'Kuwait' },
  { Id: 121, Value: '996', Name: 'Kyrgyzstan' },
  { Id: 122, Value: '856', Name: 'Laos' },
  { Id: 123, Value: '371', Name: 'Latvia' },
  { Id: 124, Value: '961', Name: 'Lebanon' },
  { Id: 125, Value: '266', Name: 'Lesotho' },
  { Id: 126, Value: '231', Name: 'Liberia' },
  { Id: 127, Value: '218', Name: 'Libya' },
  { Id: 128, Value: '423', Name: 'Liechtenstein' },
  { Id: 129, Value: '370', Name: 'Lithuania' },
  { Id: 130, Value: '352', Name: 'Luxembourg' },
  { Id: 131, Value: '853', Name: 'Macao SAR' },
  { Id: 132, Value: '389', Name: 'Macedonia, FYRO' },
  { Id: 133, Value: '261', Name: 'Madagascar' },
  { Id: 134, Value: '265', Name: 'Malawi' },
  { Id: 6, Value: '60', Name: 'Malaysia' },
  { Id: 136, Value: '960', Name: 'Maldives' },
  { Id: 137, Value: '223', Name: 'Mali' },
  { Id: 138, Value: '356', Name: 'Malta' },
  { Id: 139, Value: '692', Name: 'Marshall Islands' },
  { Id: 140, Value: '596', Name: 'Martinique' },
  { Id: 141, Value: '222', Name: 'Mauritania' },
  { Id: 142, Value: '230', Name: 'Mauritius' },
  { Id: 143, Value: '269', Name: 'Mayotte' },
  { Id: 144, Value: '52', Name: 'Mexico' },
  { Id: 145, Value: '691', Name: 'Micronesia' },
  { Id: 146, Value: '373', Name: 'Moldova' },
  { Id: 147, Value: '377', Name: 'Monaco' },
  { Id: 148, Value: '976', Name: 'Mongolia' },
  { Id: 149, Value: '382', Name: 'Montenegro' },
  { Id: 150, Value: '1664', Name: 'Montserrat' },
  { Id: 151, Value: '212', Name: 'Morocco' },
  { Id: 152, Value: '258', Name: 'Mozambique' },
  { Id: 153, Value: '95', Name: 'Myanmar' },
  { Id: 154, Value: '264', Name: 'Namibia' },
  { Id: 155, Value: '674', Name: 'Nauru' },
  { Id: 156, Value: '977', Name: 'Nepal' },
  { Id: 157, Value: '31', Name: 'Netherlands' },
  { Id: 158, Value: '687', Name: 'New Caledonia' },
  { Id: 159, Value: '64', Name: 'New Zealand' },
  { Id: 160, Value: '505', Name: 'Nicaragua' },
  { Id: 161, Value: '227', Name: 'Niger' },
  { Id: 162, Value: '234', Name: 'Nigeria' },
  { Id: 163, Value: '683', Name: 'Niue' },
  { Id: 164, Value: '6723', Name: 'Norfolk Island' },
  {
    Id: 165,
    Value: '1670',
    Name: 'Northern Mariana Islands',
  },
  { Id: 166, Value: '47', Name: 'Norway' },
  { Id: 167, Value: '968', Name: 'Oman' },
  { Id: 168, Value: '92', Name: 'Pakistan' },
  { Id: 169, Value: '680', Name: 'Palau' },
  {
    Id: 170,
    Value: '970',
    Name: 'Palestinian Authority',
  },
  { Id: 171, Value: '507', Name: 'Panama' },
  { Id: 172, Value: '675', Name: 'Papua New Guinea' },
  { Id: 173, Value: '595', Name: 'Paraguay' },
  { Id: 174, Value: '51', Name: 'Peru' },
  { Id: 7, Value: '63', Name: 'Philippines' },
  { Id: 176, Value: '872', Name: 'Pitcairn Islands' },
  { Id: 177, Value: '48', Name: 'Poland' },
  { Id: 178, Value: '351', Name: 'Portugal' },
  { Id: 179, Value: '1787', Name: 'Puerto Rico' },
  { Id: 180, Value: '974', Name: 'Qatar' },
  { Id: 181, Value: '262', Name: 'Reunion' },
  { Id: 182, Value: '40', Name: 'Romania' },
  { Id: 183, Value: '7', Name: 'Russia' },
  { Id: 184, Value: '250', Name: 'Rwanda' },
  { Id: 185, Value: '590', Name: 'Saint Barthelemy' },
  {
    Id: 186,
    Value: '290',
    Name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    Id: 187,
    Value: '1869',
    Name: 'Saint Kitts and Nevis',
  },
  { Id: 188, Value: '1758', Name: 'Saint Lucia' },
  { Id: 189, Value: '590', Name: 'Saint Martin' },

  {
    Id: 190,
    Value: '508',
    Name: 'Saint Pierre and Miquelon',
  },
  {
    Id: 191,
    Value: '1784',
    Name: 'Saint Vincent and the Grenadines',
  },
  { Id: 192, Value: '685', Name: 'Samoa' },
  { Id: 193, Value: '378', Name: 'San Marino' },
  {
    Id: 194,
    Value: '239',
    Name: 'Sao Tome and Principe',
  },
  { Id: 195, Value: '966', Name: 'Saudi Arabia' },
  { Id: 196, Value: '221', Name: 'Senegal' },
  { Id: 197, Value: '381', Name: 'Serbia' },
  { Id: 198, Value: '248', Name: 'Seychelles' },
  { Id: 199, Value: '232', Name: 'Sierra Leone' },
  { Id: 8, Value: '65', Name: 'Singapore' },
  { Id: 201, Value: '1721', Name: 'Sint Maarten' },
  { Id: 202, Value: '421', Name: 'Slovakia' },
  { Id: 203, Value: '386', Name: 'Slovenia' },
  { Id: 204, Value: '677', Name: 'Solomon Islands' },
  { Id: 205, Value: '252', Name: 'Somalia' },
  { Id: 206, Value: '27', Name: 'South Africa' },
  {
    Id: 207,
    Value: '500',
    Name: 'South Georgia and the South Sandwich Islands',
  },
  { Id: 208, Value: '211', Name: 'South Sudan' },
  { Id: 209, Value: '34', Name: 'Spain' },
  { Id: 210, Value: '94', Name: 'Sri Lanka' },
  { Id: 211, Value: '249', Name: 'Sudan' },
  { Id: 212, Value: '597', Name: 'Suriname' },
  {
    Id: 213,
    Value: '47',
    Name: 'Svalbard and Jan Mayen',
  },
  { Id: 214, Value: '268', Name: 'Swaziland' },
  { Id: 215, Value: '46', Name: 'Sweden' },
  { Id: 216, Value: '41', Name: 'Switzerland' },
  { Id: 217, Value: '963', Name: 'Syria' },
  { Id: 9, Value: '886', Name: 'Taiwan' },
  { Id: 219, Value: '992', Name: 'Tajikistan' },
  { Id: 220, Value: '255', Name: 'Tanzania' },
  { Id: 10, Value: '66', Name: 'Thailand' },
  { Id: 222, Value: '670', Name: 'Timor-Leste' },
  { Id: 223, Value: '228', Name: 'Togo' },
  { Id: 224, Value: '690', Name: 'Tokelau' },
  { Id: 225, Value: '676', Name: 'Tonga' },
  { Id: 226, Value: '1868', Name: 'Trinidad and Tobago' },
  { Id: 227, Value: '216', Name: 'Tunisia' },
  { Id: 228, Value: '90', Name: 'Turkey' },
  { Id: 229, Value: '993', Name: 'Turkmenistan' },
  {
    Id: 230,
    Value: '1649',
    Name: 'Turks and Caicos Islands',
  },
  { Id: 231, Value: '688', Name: 'Tuvalu' },
  { Id: 232, Value: '256', Name: 'Uganda' },
  { Id: 233, Value: '380', Name: 'Ukraine' },
  { Id: 234, Value: '971', Name: 'United Arab Emirates' },
  { Id: 235, Value: '44', Name: 'United Kingdom' },
  {
    Id: 237,
    Value: '1',
    Name: 'US Minor Outlying Islands',
  },
  { Id: 11, Value: '1', Name: 'USA' },
  { Id: 238, Value: '598', Name: 'Uruguay' },
  { Id: 239, Value: '998', Name: 'Uzbekistan' },
  { Id: 240, Value: '678', Name: 'Vanuatu' },
  { Id: 241, Value: '58', Name: 'Venezuela' },
  { Id: 242, Value: '84', Name: 'Vietnam' },
  { Id: 244, Value: '1340', Name: 'Virgin Islands (U.S.)' },
  { Id: 245, Value: '681', Name: 'Wallis and Futuna' },
  { Id: 246, Value: '212', Name: 'Western Sahara' },
  { Id: 247, Value: '967', Name: 'Yemen' },
  { Id: 248, Value: '260', Name: 'Zambia' },
  { Id: 249, Value: '263', Name: 'Zimbabwe' },
];
